var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name === 'FlashLab')?_c('div',[_c('span',[_vm._v("请在旁侧栏选择要使用的工具")])]):_c('div',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }